import React from 'react';

const Certificazione = ({
    text_casalingo,
    }) => {
    return (
        <>
            <div style={{padding:'20px'}}>DICHIARA</div>
            di avere la qualità di {text_casalingo}
        </>
        );
    }

export default Certificazione;